/**
 * The icon badge of the result of AI Music Detector.
 *
 * Author: Bounlith Sirivong <bounlith.sirivong@ircamamplify.com>
 * Copyright © Ircam Amplify 2025
 */
interface AiMusicDetectorBadgeProps {
  isAi: boolean
  className?: string
}

const AiMusicDetectorBadge = (props: AiMusicDetectorBadgeProps) => {
  const iconFile = props.isAi
    ? '/icon/result-badge-wrong.svg'
    : '/icon/result-badge-good.svg'
  const iconAlt = props.isAi ? 'Ai badge' : 'Human-created badge'

  return <img className={props.className} src={iconFile} alt={iconAlt} />
}

export default AiMusicDetectorBadge
